// Turf = {
// 	pointToLineDistance: require('@turf/point-to-line-distance').default,
// 	explode: require('@turf/explode').default,
// 	nearestPoint: require('@turf/nearest-point').default,
// 	distance: require('@turf/distance').default,
// 	booleanContains: require('@turf/boolean-contains').default
// };
export default {
	pointToLineDistance: require('@turf/point-to-line-distance').default,
	explode: require('@turf/explode').default,
	nearestPoint: require('@turf/nearest-point').default,
	distance: require('@turf/distance').default,
	booleanContains: require('@turf/boolean-contains').default,
	bbox: require('@turf/bbox').default,
};
